import type { TrendListResponsePageAllOfThreeContentItemAuth } from './trendListResponsePageAllOfThreeContentItemAuth';
import type { TrendListResponsePageAllOfThreeContentItemBasicInfo } from './trendListResponsePageAllOfThreeContentItemBasicInfo';
import type { TrendListResponsePageAllOfThreeContentItemContent } from './trendListResponsePageAllOfThreeContentItemContent';
import type { TrendListResponsePageAllOfThreeContentItemStats } from './trendListResponsePageAllOfThreeContentItemStats';

export type TrendListResponsePageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: TrendListResponsePageAllOfThreeContentItemAuth;
  basicInfo?: TrendListResponsePageAllOfThreeContentItemBasicInfo;
  /** 트렌드 관련 콘텐츠 */
  content?: TrendListResponsePageAllOfThreeContentItemContent;
  /** 트렌드 통계 정보 */
  stats?: TrendListResponsePageAllOfThreeContentItemStats;
};
